import { BaseResponse } from "../../../models/response/base.response";

export class PendingOrganizationInvitationResponse extends BaseResponse {
  organizationId: string;
  organizationName: string;
  organizationUserId: string;
  invitedByEmail: string | null;
  token: string;

  constructor(response: any) {
    super(response);
    this.organizationId = this.getResponseProperty("OrganizationId");
    this.organizationName = this.getResponseProperty("OrganizationName");
    this.organizationUserId = this.getResponseProperty("OrganizationUserId");
    this.invitedByEmail = this.getResponseProperty("InvitedByEmail");
    this.token = this.getResponseProperty("Token");
  }
}
